/* ============================= */
/* VERSION V1.1 - HOME */
/* ============================= */

import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Apropos from "../components/Apropos";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Reservation from "../components/Reservation";
import SeoLocal from "../components/SeoLocal";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import "../styles/Home.css";

/* Fade-in propre */
const useFadeInOnScroll = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-in");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
};

const Home = () => {
  useFadeInOnScroll();

  return (
    <>
      <Navbar />

      {/* HERO */}
      <section id="hero" className="fade-in">
        <Hero />
      </section>

      {/* À PROPOS */}
      <section id="apropos" className="fade-in">
        <Apropos />
      </section>

      {/* SERVICES */}
      <section id="services" className="fade-in">
        <Services />
      </section>

      {/* RÉSERVATION */}
      <section id="reservation" className="fade-in">
        <Reservation />
      </section>

      {/* CONTACT */}
      <section id="contact" className="fade-in">
        <Contact />
      </section>

      {/* SEO LOCAL */}
      <section className="fade-in">
        <SeoLocal />
      </section>
      <FloatingButtons/>
      <Footer />
    </>
  );
};

export default Home;

















